import {
  pageElementViewTrackingFunction,
  PageElementViewTrackingParam,
} from '@utils/page-analytics/model/PageElementViewedTracking';
import { IntersectionOptions, useInView } from 'react-intersection-observer';

export const useInViewTracking = (
  createParam: () => PageElementViewTrackingParam,
  options: Partial<IntersectionOptions> = { threshold: 1, triggerOnce: true },
) => {
  const { ref } = useInView({
    /* Optional options */
    ...options,
    onChange: (inView: boolean) => {
      if (inView) {
        const params = createParam();
        pageElementViewTrackingFunction(params);
      }
    },
  });

  return { ref };
};
